import styled, { css } from 'styled-components';

import { Text } from '~/components/ui/Text';

const StyledTextLabel = styled(Text)`
	color: #ffffff;
	font-size: 16px;
	font-weight: 400;
	transition: color 0.3s ease;
	pointer-events: none;
`;

const StyledContainer = styled.div<{ $active?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 15px;
	border-radius: 10px;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	transition: background-color 0.3s ease;
	cursor: pointer;

	${(props) =>
		!props.$active
			? css`
					&:hover {
						background-color: #ffffff;

						img {
							filter: invert(100%);
						}

						${StyledTextLabel} {
							color: #000000;
						}
					}
			  `
			: css`
					background-color: #2d70da;
			  `}

	img {
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}
`;

export { StyledContainer, StyledTextLabel };
